// @flow

export default {
  wizard: {
    next: 'Neste',
    back: 'Tilbake',
    skip: 'Hopp over',
    sort: 'Sortere',
    sorting: {
      'utility:desc': 'Beste resultatet',
      'price:asc': 'Pris stigende',
      'price:desc': 'Prisen synker',
      'created_at:desc': 'Nyeste',
      'customer_rating:desc': 'Kundevurdering'
    },
    clickToAddFiles: 'Klikk for å legge til filene dine eller slipp dem her.',
    searchFor: 'Søk etter ...',
    noSearchResults: 'Dessverre har vi ikke funnet noen passende alternativer. Vennligst søk igjen.',
    loadMoreAnswerOptions: 'Ingen passende alternativ her? Vis alle alternativer.',
    noRecommendationDescription: 'Å nei, dessverre kunne vi ikke finne noen produkter som passer dine behov.',
    noRecommendationDescription2: 'Vennligst start produktrådgiveren på nytt.',
    noRecommendationRestartButtonTitle: 'Omstart',
    noRecommendationCloseButtonTitle: 'Lukke',
    removeFile: 'Fjern filen'
  },
  chatbot: {
    selectAll: 'Velg alle',
    none: 'Ingen',
    confirmButton: 'Bekrefte',
    customerServiceInputPlaceholder: 'Skrive en melding ...',
    you: 'Du',
    restart: 'Start på nytt',
    close: 'Lukke',
    send: 'Sende',
    supportChat: 'Støttechat',
    honeypot: 'Vennligst la dette feltet stå tomt',
    scrollToTheLatestMessage: 'Bla til den siste meldingen',
    removeFile: 'Fjern filen'
  },
  product: {
    loadMore: 'Legg inn flere produkter',
    badgeTitle: 'Vår anbefaling',
    ctaButtonTitle: 'Oppdag produkt',
    matchingPanelTitle: 'Skreddersydd til dine behov',
    bestFit: 'Passer best',
    bestPrice: 'Beste pris',
    bestFitForPrice: 'Beste fit-for-Price',
    addToCartError: 'Legg i handlekurven var ikke vellykket. Vær så snill, prøv på nytt',
    addRoutineToCart: 'Legg i handlekurv',
    explanationHeader: 'Mer produktinformasjon:',
    emptyRoutineItem: 'Dessverre er det ikke noe produkt i den kategorien som samsvarer med dine preferanser.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Produktrådgiver'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Dessverre ville dette alternativet ikke føre til noe ønsket produkt. Du kan endre preferansen din i tidligere trinn for å aktivere alternativet.'
  }
}
